import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter, MemoryRouter } from "react-router-dom";
import useSunCycleTheme from "../../hooks/useSunCycleTheme";
import { useTouchDetection } from "../../hooks/useTouchDetection";
import { ToastProvider } from "../Toast";
import { createQueryClient } from "../../services/queryClient";
import { EquipmentRentalProvider } from "contexts/EquipmentRentalContext";
import { InventoryFlowProvider } from "contexts/InventoryFlowContext";
import "./i18n";
import Router from "./Router";

import "./app.scss";
import "./dark.scss";

const queryClient = createQueryClient();

function App() {
  let RouterProvider = MemoryRouter;
  if (process.env.NODE_ENV === "development") RouterProvider = BrowserRouter;

  useSunCycleTheme();

  // Add touch detection with default settings
  useTouchDetection();

  return (
    <ToastProvider>
      <QueryClientProvider client={queryClient}>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        <RouterProvider>
          <InventoryFlowProvider>
            <EquipmentRentalProvider>
              <Router />
            </EquipmentRentalProvider>
          </InventoryFlowProvider>
        </RouterProvider>
      </QueryClientProvider>
    </ToastProvider>
  );
}

export default App;
